// extracted by mini-css-extract-plugin
export default {"removeWrapper":"WindFacilityForm_removeWrapper__HDiyt","checkBoxWithInfoIcon":"WindFacilityForm_checkBoxWithInfoIcon__AI3wd","infoIcon":"WindFacilityForm_infoIcon__ScYmS"};